import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './componentparameters.css'

const Componentparameters = (props) => {
  return (
    <div className={`componentparameters-container1 ${props.rootClassName} `}>
      {props.showH2 === false && (
        <h2 className="componentparameters-text10">{props.mainHeading}</h2>
      )}
      <div className="componentparameters-container2">
        {props.showDiv1 === true && (
          <div className="componentparameters-container3">
            <h3 className="componentparameters-text11 H1_extrasmall">
              {props.heading1}
            </h3>
            <span className="componentparameters-text12">
              {props.text1 ?? (
                <Fragment>
                  <span className="componentparameters-text23">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        )}
        {props.showDiv2 === true && (
          <div className="componentparameters-container4">
            <h3 className="componentparameters-text13">{props.heading2}</h3>
            <span className="componentparameters-text14">
              {props.text2 ?? (
                <Fragment>
                  <span className="componentparameters-text24">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        )}
        {props.showDiv3 === true && (
          <div className="componentparameters-container5">
            <h3 className="componentparameters-text15 H1_extrasmall">
              {props.heading3}
            </h3>
            <span className="componentparameters-text16">
              {props.text3 ?? (
                <Fragment>
                  <span className="componentparameters-text22">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        )}
        {props.showDiv4 === true && (
          <div className="componentparameters-container6">
            <h3 className="componentparameters-text17 H1_extrasmall">
              {props.heading4}
            </h3>
            <span className="componentparameters-text18">
              {props.text4 ?? (
                <Fragment>
                  <span className="componentparameters-text25">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        )}
        {props.showDiv5 === true && (
          <div className="componentparameters-container7">
            <h3 className="componentparameters-text19 H1_extrasmall">
              {props.heading5}
            </h3>
            <span className="componentparameters-text20">
              {props.text5 ?? (
                <Fragment>
                  <span className="componentparameters-text21">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur
                  </span>
                </Fragment>
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

Componentparameters.defaultProps = {
  showDiv1: true,
  heading2: 'Heading2',
  text5: undefined,
  showDiv3: true,
  mainHeading: 'Main Heading',
  heading1: 'Heading1',
  text3: undefined,
  showDiv4: true,
  showH2: false,
  text1: undefined,
  text2: undefined,
  heading3: 'Heading3',
  rootClassName: '',
  heading4: 'Heading4',
  heading5: 'Heading5',
  showDiv5: true,
  showDiv2: true,
  text4: undefined,
}

Componentparameters.propTypes = {
  showDiv1: PropTypes.bool,
  heading2: PropTypes.string,
  text5: PropTypes.element,
  showDiv3: PropTypes.bool,
  mainHeading: PropTypes.string,
  heading1: PropTypes.string,
  text3: PropTypes.element,
  showDiv4: PropTypes.bool,
  showH2: PropTypes.bool,
  text1: PropTypes.element,
  text2: PropTypes.element,
  heading3: PropTypes.string,
  rootClassName: PropTypes.string,
  heading4: PropTypes.string,
  heading5: PropTypes.string,
  showDiv5: PropTypes.bool,
  showDiv2: PropTypes.bool,
  text4: PropTypes.element,
}

export default Componentparameters
